import { Col } from "antd";
import styled from "styled-components";

export const CenteredColumn = styled(Col)({
    display: 'flex',
    justifyContent: 'center'
});
